import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { Drawer } from '@/models/drawer.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDrawer',
  setup(__props) {

const store = useStore<ShiftCMSState>();

const drawer = computed<Drawer>(() => store.state.drawer);
const subDrawer = computed<Drawer>(() => store.state.subDrawer);

const dirtyState = computed<boolean>(() => store.state.dirtyState);

const hideDrawer = () => {
  if (dirtyState.value) {
    store.dispatch(Actions.ShowNotification, {
      message: 'You have unsaved changes',
      type: 'warning',
    });
    return;
  }
  store.commit(Mutations.HideSubDrawer);
  store.commit(Mutations.HideDrawer);
};
const hideSubDrawer = () => {
  store.commit(Mutations.HideSubDrawer);
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (drawer.value.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "drawer-backdrop",
          onClick: hideDrawer
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["drawer", {
      show: drawer.value.show,
      medium: drawer.value.medium,
      double: subDrawer.value.show,
      half: subDrawer.value.small,
    }])
    }, [
      _createVNode(_component_v_btn, {
        icon: "mdi-close-circle-outline",
        density: "compact",
        class: "close-button",
        onClick: _withModifiers(hideDrawer, ["prevent"])
      }),
      (_openBlock(), _createBlock(_resolveDynamicComponent(drawer.value.component), {
        data: drawer.value.data
      }, null, 8, ["data"]))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["drawer sub-drawer", { show: subDrawer.value.show, 'drawer-small': subDrawer.value.small }])
    }, [
      _createVNode(_component_v_btn, {
        icon: "mdi-close-circle-outline",
        density: "compact",
        class: "close-button",
        onClick: _withModifiers(hideSubDrawer, ["prevent"])
      }),
      (_openBlock(), _createBlock(_resolveDynamicComponent(subDrawer.value.component), {
        data: subDrawer.value.data
      }, null, 8, ["data"]))
    ], 2)
  ], 64))
}
}

})